import * as React from 'react';
import store from './redux/store';
import App from './components/App';
import { Auth0Provider } from '@auth0/auth0-react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import history from './util/history';
import { getVitePublicEnv } from './runtimeEnv';
import './less/styles.less';

const onRedirectCallback = (appState) => {
    if (appState.returnTo) {
        history.push(appState?.returnTo);
    }
};

render(
    <Auth0Provider
        clientId={getVitePublicEnv('VITE_AUTH0_CLIENT_ID')}
        domain={getVitePublicEnv('VITE_AUTH0_DOMAIN')}
        onRedirectCallback={onRedirectCallback}
        useRefreshTokens={true}
        cacheLocation='localstorage'
        authorizationParams={{
            redirect_uri: window.location.origin,
            scope: 'openid',
            audience: 'https://api.4cinsights.io/'
        }}>
        <Provider store={store}>
            <Router history={history}>
                <Switch>
                    <Redirect
                        from='/auth'
                        to='/'
                    />
                    <Route
                        path='/:org_id?/:story_id?'
                        component={App}
                    />
                </Switch>
            </Router>
        </Provider>
    </Auth0Provider>,
    document.getElementById('react-root')
);
